/**
 * Creates a deep copy of a variable with no pointer references. 
 * @param object Any datatype NOT containing a function.
 * @returns The same datatype that was passed to it.
 * @source https://developer.mozilla.org/en-US/docs/Glossary/Deep_copy
 */
export default function deepCopyOf<T extends any>(object: T){
  return JSON.parse(JSON.stringify(object)) as T
}